import type { ReactNode } from 'react';
import { Button, Form } from 'react-bootstrap';
import type { TFunction } from 'i18next';
import ReservationFormLabel from './ReservationFormLabel';
import RsDateTimeLocalInput from './RsDateTimeLocalInput';
import styles from './ReservationBoardCalendar.module.css';

type RsTimeNudgeButtonProps = {
  children: ReactNode;
  onClick: () => void;
  variant?: 'outline-secondary' | 'outline-primary';
  title?: string;
  'aria-label'?: string;
};

export function RsTimeNudgeButton({
  children,
  onClick,
  variant = 'outline-secondary',
  title,
  'aria-label': ariaLabel,
}: RsTimeNudgeButtonProps) {
  return (
    <Button
      type="button"
      variant={variant}
      size="sm"
      className={styles.dateTimeNudgeBtn}
      onClick={onClick}
      title={title}
      aria-label={ariaLabel}
    >
      {children}
    </Button>
  );
}

type RsDateTimeFieldGroupProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  min?: string;
  locale: string;
  nudgeAriaLabel: string;
  nudges: ReactNode;
  t: TFunction;
  /** ラベル行右の補助（枠時間など） */
  labelMeta?: ReactNode;
  includeOvernightContinuation?: boolean;
};

/** 日時入力＋±30 ナッジ（開始／終了の重複マークアップを1箇所に） */
export default function RsDateTimeFieldGroup({
  label,
  value,
  onChange,
  min,
  locale,
  nudgeAriaLabel,
  nudges,
  t,
  labelMeta,
  includeOvernightContinuation,
}: RsDateTimeFieldGroupProps) {
  return (
    <Form.Group className="mb-2">
      <ReservationFormLabel label={label} t={t} meta={labelMeta} />
      <div className={styles.dateTimeRow}>
        <div className={styles.dateTimeField}>
          <RsDateTimeLocalInput
            value={value}
            onChange={onChange}
            min={min}
            locale={locale}
            required
            includeOvernightContinuation={includeOvernightContinuation}
            aria-label={label}
          />
        </div>
        <div className={styles.dateTimeNudge} role="group" aria-label={nudgeAriaLabel}>
          {nudges}
        </div>
      </div>
    </Form.Group>
  );
}
